"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFedopsLogger = void 0;
const createFedopsLogger = () => {
    const Noop = (..._args) => { };
    const NoopWithTimeout = (..._args) => ({ timeoutId: 0 });
    return {
        createFedopsLogger: (_mock) => {
            return {
                interactionStarted: NoopWithTimeout,
                interactionEnded: Noop,
                appLoadingPhaseStart: Noop,
                appLoadingPhaseFinish: Noop,
                appLoadStarted: Noop,
                appLoaded: Noop,
            };
        },
    };
};
exports.createFedopsLogger = createFedopsLogger;
//# sourceMappingURL=fedopsLogger.js.map